import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Modal,
  AvatarGroup,
  Avatar,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import VisibilityIcon from "@mui/icons-material/Visibility";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import WatchLaterRoundedIcon from "@mui/icons-material/WatchLaterRounded";
import ReyleafLogo from "../../common/assests/reyleafLogo.svg";
import Adminimg from "../../common/assests/adminimg.png";
import Paginations from "../../common/pagination/Paginations";
import { useSelector } from "react-redux";
import {
  blockVenderEventApi,
  deleteVenderEventApi,
  getAllEventsApi,
  resumeVenderEventApi,
  unpublishEventApi,
} from "../../api";
import Loader from "../../common/loader/Loader";
import { toast } from "react-toastify";
import { useConfirm } from "../../common/confirmDialog/useConfirm";
import "./EventManagement.css";
import configuration from "../../config/Config";

const EventManagement = () => {
  const token = useSelector((state) => state?.user?.user?.token);
  const confirm = useConfirm();
  const [open, setOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [eventDetailsData, setEventDetailsData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState();
  const [loading, setLoading] = useState(false);
  const [change, setChange] = useState(false);

  const handleClose = () => setOpen(false);

  const handleEventApi = async () => {
    try {
      setLoading(true);
      const response = await getAllEventsApi({ token, currentPage });
      setEventDetailsData(response?.events || []);
      setCurrentPage(response?.currentPage);
      setTotalPages(response?.totalPages);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };

  useEffect(() => {
    handleEventApi();
  }, [currentPage, change]);

  const handleBlock = async (id) => {
    if (!await confirm({ title: "Block Event", description: "Are you sure you want to block this event?", confirmText: "Block" })) return;
    try {
      const response = await blockVenderEventApi({ token, id });
      setChange(!change);
      toast.success(response?.message);
      setOpen(false);
    } catch (error) {
      toast.error(error?.status === 500 ? "Some error occurred" : error?.error);
    }
  };

  const handleResume = async (id) => {
    if (!await confirm({ title: "Publish Event", description: "Are you sure you want to publish this event?", confirmText: "Publish" })) return;
    try {
      const response = await resumeVenderEventApi({ token, id });
      setChange(!change);
      toast.success(response?.message);
      setOpen(false);
    } catch (error) {
      toast.error(error?.status === 500 ? "Some error occurred" : error?.error);
    }
  };

  const handleDelete = async (id) => {
    if (!await confirm({ title: "Delete Event", description: "Are you sure you want to delete this event?", confirmText: "Delete", destructive: true })) return;
    try {
      const response = await deleteVenderEventApi({ token, id });
      setChange(!change);
      toast.success(response.message);
      setOpen(false);
    } catch (error) {
      toast.error(error?.status === 500 ? "Some error occurred" : error?.error);
    }
  };

  const handleUnPublish = async (id) => {
    if (!await confirm({ title: "Unpublish Event", description: "Are you sure you want to unpublish this event?", confirmText: "Unpublish" })) return;
    try {
      const response = await unpublishEventApi({ token, id });
      setChange(!change);
      toast.success(response?.message);
      setOpen(false);
    } catch (error) {
      toast.error(error?.status === 500 ? "Some error occurred" : error?.error);
    }
  };

  const handleOpen = (event) => {
    setSelectedEvent(event);
    setOpen(true);
  };

  const handlePageChange = (page) => {
    setLoading(true);
    setCurrentPage(page);
  };

  return (
    <div>
      {loading ? (
        <Loader variant="cardList" />
      ) : (
        <>
          <Box className="sidebarTab-eventManagement">
            <Typography className="sidebarTab-eventManagement-header">
              All Platform Events
            </Typography>
            <Box>
              {eventDetailsData?.length > 0 ? (
                eventDetailsData.map((item) => (
                  <Box key={item?._id} className="sidebarTab-eventCard">
                    <Box className="sidebarTab-eventDetails">
                      <img
                        src={item?.picture ? `${configuration.cdnFront}/${item?.picture}` : ReyleafLogo}
                        alt="Event"
                        className="sidebarTab-eventImage"
                      />
                      <Box>
                        <Box className="sidebarTab-eventHeader">
                          <Typography className="sidebarTab-eventContent">
                            {item?.title || "N/A"}
                          </Typography>
                          <WatchLaterRoundedIcon sx={{ fontSize: 16, color: "#065F46", mx: 0.5 }} />
                          <Typography className="sidebarTab-eventDate">
                            {item?.eventDate
                              ? new Date(item?.eventDate).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })
                              : "N/A"}
                          </Typography>
                        </Box>
                        <Typography className="sidebarTab-eventCategory">
                          {item?.category || "N/A"}
                        </Typography>
                        <Typography className="sidebarTab-eventDescription">
                          {item?.description || "N/A"}
                        </Typography>
                      </Box>
                    </Box>
                    <Box className="sidebarTab-actionIcons">
                      <IconButton onClick={() => handleOpen(item)} sx={{ color: "#065F46" }}>
                        <VisibilityIcon />
                      </IconButton>
                      <IconButton
                        onClick={() =>
                          item?.status === "active"
                            ? handleBlock(item?._id)
                            : handleResume(item?._id)
                        }
                        sx={{ color: "#362B24" }}
                      >
                        {item?.status === "active" ? <LockIcon /> : <LockOpenIcon />}
                      </IconButton>
                      <IconButton onClick={() => handleDelete(item?._id)} sx={{ color: "#EA001B" }}>
                        <DeleteIcon />
                      </IconButton>
                    </Box>
                  </Box>
                ))
              ) : (
                <div style={{ textAlign: "center" }}>No Data Found</div>
              )}
            </Box>
            <Paginations
              totalPages={totalPages}
              currentPage={currentPage}
              onPageChange={handlePageChange}
              disabled={loading}
            />
          </Box>

          {/* Detail modal */}
          <Modal open={open} onClose={handleClose}>
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: { xs: "80vw", sm: "80vw" },
                maxWidth: "650px",
                bgcolor: "#FFF",
                borderRadius: "32px",
                boxShadow: 24,
                maxHeight: "80vh",
                p: 4,
                overflowY: "auto",
                "&::-webkit-scrollbar": { display: "none" },
                "@media (min-width: 1600px)": { width: "90vw" },
                "@media (max-width: 1400px)": { width: "80vw" },
                "@media (max-width: 1200px)": { width: "70vw" },
                "@media (max-width: 1024px)": { width: "60vw" },
                "@media (max-width: 767px)": { width: "80vw" },
                "@media (max-width: 576px)": { width: "90vw" },
                "@media (max-width: 480px)": { width: "95vw" },
              }}
            >
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Typography sx={{ fontSize: "20px", fontWeight: "700" }}>Event Details</Typography>
                <IconButton onClick={handleClose}>
                  <CloseIcon />
                </IconButton>
              </Box>

              {selectedEvent && (
                <>
                  <img
                    src={selectedEvent?.picture ? `${configuration.cdnFront}/${selectedEvent?.picture}` : ReyleafLogo}
                    alt="Event"
                    style={{ width: "100%", maxHeight: "263px", borderRadius: "20px", marginTop: "15px" }}
                  />

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      flexDirection: { xs: "column", sm: "row" },
                      gap: 2,
                      mt: 3,
                    }}
                  >
                    <Typography sx={{ fontSize: "18px", fontWeight: "700", color: "#362B24", fontFamily: "Heebo" }}>
                      {selectedEvent?.title || "N/A"}
                    </Typography>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <AvatarGroup
                        renderSurplus={(surplus) => <span>+{surplus.toString()[0]}k</span>}
                        total={selectedEvent?.members?.length || 0}
                        sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
                      >
                        {selectedEvent?.members?.slice(0, 3).map((member, index) => (
                          <Avatar
                            key={index}
                            alt={member?.name || "Anonymous"}
                            src={member?.avatar || Adminimg}
                            sx={{ width: "25px", height: "25px" }}
                          />
                        ))}
                      </AvatarGroup>
                      <Typography sx={{ fontWeight: "400", color: "#362B24", fontFamily: "Heebo", fontSize: { xs: "10px", sm: "18px" } }}>
                        {selectedEvent?.joinedCount || "0"} Attendance
                      </Typography>
                    </Box>
                  </Box>

                  <Box sx={{ display: "flex", justifyContent: "start", alignItems: "center", gap: 3, marginTop: "20px", flexWrap: "wrap" }}>
                    <Box
                      sx={{
                        borderRadius: "28px",
                        background: "#362B24",
                        boxShadow: "1px 2px 30px 0px rgba(0, 0, 0, 0.06)",
                        width: "110px",
                        height: "30px",
                        display: "flex",
                        alignItems: "center",
                        padding: "0 8px",
                        flexShrink: 0,
                        gap: 1,
                      }}
                    >
                      <WatchLaterRoundedIcon sx={{ color: "#FFF", width: "18px", height: "18px" }} />
                      <Typography sx={{ color: "#FFF", fontSize: "10px" }}>
                        {selectedEvent?.eventDate
                          ? new Date(selectedEvent?.eventDate).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })
                          : "N/A"}
                      </Typography>
                    </Box>

                    <Typography sx={{ fontWeight: "400", color: "#362B24", fontSize: "13px", fontFamily: "Heebo" }}>
                      {selectedEvent?.category || "N/A"}
                    </Typography>

                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                      <LocationOnIcon sx={{ color: "#065F46", fontSize: 18 }} />
                      <Typography sx={{ color: "#065F46", fontSize: "13px", fontWeight: "400", fontFamily: "Heebo" }}>
                        {selectedEvent?.address || "N/A"}
                      </Typography>
                    </Box>
                  </Box>

                  <Typography sx={{ fontSize: "17px", fontWeight: "600", color: "#362B24", fontFamily: "Heebo", mt: 3 }}>
                    Description
                  </Typography>
                  <Typography sx={{ mb: 2, opacity: 0.5, fontFamily: "Heebo" }}>
                    {selectedEvent?.description || "N/A"}
                  </Typography>

                  <Box sx={{ display: "flex", gap: 1, justifyContent: "center", flexWrap: "wrap", marginTop: "25px" }}>
                    <Button
                      onClick={() =>
                        selectedEvent?.status === "active"
                          ? handleUnPublish(selectedEvent?._id)
                          : handleResume(selectedEvent?._id)
                      }
                      startIcon={selectedEvent?.status === "active" ? <LockIcon /> : <LockOpenIcon />}
                      sx={{
                        borderRadius: "15px",
                        bgcolor: selectedEvent?.status === "active" ? "#d7d5d3" : "#362B24",
                        maxWidth: "190px",
                        width: "100%",
                        height: "50px",
                        flexShrink: 0,
                        color: selectedEvent?.status === "active" ? "#362B24" : "#FFF",
                        fontFamily: "Heebo",
                        textTransform: "none",
                        "&:hover": { bgcolor: selectedEvent?.status === "active" ? "#d7d5d3" : "#362B24" },
                      }}
                    >
                      {selectedEvent?.status === "active" ? "Unpublish" : "Publish"}
                    </Button>
                    <Button
                      onClick={() => handleDelete(selectedEvent?._id)}
                      startIcon={<DeleteIcon />}
                      sx={{
                        borderRadius: "15px",
                        bgcolor: "#EA001B",
                        maxWidth: "190px",
                        width: "100%",
                        height: "50px",
                        flexShrink: 0,
                        color: "#FFF",
                        fontFamily: "Heebo",
                        textTransform: "none",
                        "&:hover": { bgcolor: "#EA001B" },
                      }}
                    >
                      Delete
                    </Button>
                  </Box>
                </>
              )}
            </Box>
          </Modal>
        </>
      )}
    </div>
  );
};

export default EventManagement;
